import Announcements from './Announcements.container';

// announcements list
import './ANGSearchOptIn';
import './ANGSearchOptOut';
import './ANGTemporarilyDisabled';
import './OmniBanner';

export default Announcements;
